import { render, staticRenderFns } from "./XCloseModalButton.vue?vue&type=template&id=32edf8ca"
import script from "./XCloseModalButton.vue?vue&type=script&lang=js"
export * from "./XCloseModalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports